import PilotWechatCrawlRunModeAPI from 'dashboard/api/pilot/wechatCrawlRunMode';

const types = {
  SET_UI_FLAG: 'SET_UI_FLAG',
  SET_OUTBOUND_SERVICE_URL: 'SET_OUTBOUND_SERVICE_URL',
};

export default {
  namespaced: true,

  state: {
    uiFlags: {
      isFetching: false,
    },
    outboundServiceUrl: '',
  },

  mutations: {
    [types.SET_UI_FLAG](state, data) {
      state.uiFlags = { ...state.uiFlags, ...data };
    },
    [types.SET_OUTBOUND_SERVICE_URL](state, url) {
      state.outboundServiceUrl = url;
    },
  },

  actions: {
    async fetch({ commit }) {
      commit(types.SET_UI_FLAG, { isFetching: true });
      try {
        const { data } = await PilotWechatCrawlRunModeAPI.show();
        commit(types.SET_OUTBOUND_SERVICE_URL, data.outbound_service_url);
        commit(types.SET_UI_FLAG, { isFetching: false });
        return data;
      } catch (error) {
        commit(types.SET_UI_FLAG, { isFetching: false });
        throw error;
      }
    },

    async generateCrawlUrl(_, kbId = null) {
      const { data } = await PilotWechatCrawlRunModeAPI.generateCrawlUrl(kbId);
      return data;
    },
  },
};
